module.exports = __webpack_public_path__ + "static/media/bitmap.3299e5f6.jpg";